module.exports = __webpack_public_path__ + "img/Gift_Bilde-av-boken-Hovedstrømninger.0e23b9b7.jpg";